/**
 * Texture alpha access used to build tile collision outlines. The browser implementation reads
 * decoded images through a canvas, the node implementation (tools/play) decodes PNGs with pngjs.
 */
export interface AlphaImage {
  w: number;
  h: number;
  /** alpha 0..255, row 0 = top of the texture */
  data: Uint8Array;
}

export interface PixelSource {
  alpha(tex: string): AlphaImage | null;
}

/** Wrap a loader with a cache. */
export function cachedPixelSource(load: (tex: string) => AlphaImage | null): PixelSource {
  const cache = new Map<string, AlphaImage | null>();
  return {
    alpha(tex) {
      if (!cache.has(tex)) cache.set(tex, load(tex));
      return cache.get(tex)!;
    },
  };
}
